<template>
  <div>
    <template v-if="isLoading">
      <template v-if="!isError">
        <loading :message="'データ読み込み中...'"></loading>
      </template>
    </template>
    <template v-else>

      <template v-for="renraku in dataList">
        <div id="comment-list">

          <!-- 会社連絡 -->

          <article class="post-type-comment other">
            <div class=" icon">
              <img :src="Const.PEOPLE_ICON_PATH">
            </div>
            <div class="post-body">
              <div class="post-info">
                <p class="date">{{ dateFormat(renraku.created_at) }}　{{ timeFormat(renraku.created_at) }}</p>
                <!--
                現在はレコード作成日時が表示されているが掲載期間を表示したいという要望があったらここを外す
                <p class="date">
                  <span class="start">{{ dateFormat(renraku.start_datetime) }} {{ timeFormat(renraku.start_datetime) }}</span>
                  <span class="end" v-if="renraku.start_datetime !== renraku.end_datetime"> ～ {{ dateFormat(renraku.end_datetime) }} {{ timeFormat(renraku.end_datetime) }}</span>

                </p> -->
              </div>
              <div class="post-content">
                <template v-if="renraku.isUpdating">
                  <loading :message="'更新中...'"></loading>
                </template>
                <template v-else>
                  <button type="button" class="btn success" @click="toKidoku(renraku)" v-if="!renraku.isKidoku">
                    既読にする <i class="fas"></i>
                  </button>
                </template>

                <p class="pre-wrap transform-italic">{{ renraku.title }}</p>
              </div>
            </div>
          </article>

        </div>
      </template>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { dateFormat, timeFormat } from "@/filters/common";
import { RenrakuForList } from "@/types/KaisyaRenraku";
import { OshiraseService } from "@/service/OshiraseService";
import Const from '@/const/Shinsei/Option';

export default defineComponent({
  props: {
    dataList: {
      type: Object as () => RenrakuForList[],
      require: true,
    },
    isLoading: {
      type: Boolean,
      require: false,
    },
    isError: {
      type: Boolean,
      require: false,
    },
  },
  setup(props) {
    const isUpdating = ref(false);

    const oshiraseService = new OshiraseService();

    // 既読処理
    const toKidoku = async (renraku: RenrakuForList) => {
      renraku.isUpdating = true; // isUpdatingはここで初めて定義される
      await oshiraseService.updateToRead(renraku.oshirase_id);
      renraku.isKidoku = true; // あくまでクライアント側でのみの更新なので不都合があればemitして取り直す実装へ変更すること
      renraku.isUpdating = false;
    };

    return {
      dateFormat,
      timeFormat,
      Const,
      isUpdating,
      toKidoku,
    };
  },
  components: {},
});
</script>

<style lang="scss" scoped>
@import '@scss/components/renraku-detail.scss';
</style>
